import { type FC, type PropsWithChildren, useId } from 'react';

import { Box, RadioCard, Stretch } from '@eneco/sparky';

import {
  ProductCardContent,
  ProductCardFrame,
  type ProductCardContentProps,
  type ProductCardFrameProps,
} from './ProductCardContent';

interface Props extends Omit<ProductCardContentProps, 'id' | 'titleSuffix'>, ProductCardFrameProps {
  id: string;
  isOpen?: boolean;
}

export const ProductCard: FC<PropsWithChildren<Props>> = ({
  id: productId,
  title,
  subtitle,
  ribbon,
  touRibbon,
  tag,
  price,
  secondaryPrice,
  isOpen,
  usps,
  children,
}) => {
  const id = useId();
  const WrapperComponent = isOpen ? Box : Stretch;

  return (
    <WrapperComponent>
      <ProductCardFrame ribbon={ribbon} touRibbon={touRibbon}>
        <RadioCard value={productId} ariaLabelledby={`${id}-label ${id}-price`}>
          <ProductCardContent
            id={id}
            title={title}
            subtitle={subtitle}
            tag={tag}
            price={price}
            secondaryPrice={secondaryPrice}
            usps={usps}
            titleSuffix={<RadioCard.Indicator />}>
            {children}
          </ProductCardContent>
        </RadioCard>
      </ProductCardFrame>
    </WrapperComponent>
  );
};
